import WriteTodoWordArea from "@/pages/comp/plan/todo/common/write_todo_word";

function WriteTodoWordPopup(props: any) {
  let myProps = {
    stu_seq_arr: [],
    todo_data_arr: [],
    closePopup: () => { },
    callbackData: (inData: any) => { },
    ...props
  };

  return (
    <div>
      <WriteTodoWordArea
        stu_seq_arr={myProps.stu_seq_arr}
        todo_data_arr={myProps.todo_data_arr}
        closePopup={myProps.closePopup}
        callbackData={myProps.callbackData}
      ></WriteTodoWordArea>
    </div>
  );
};
export default WriteTodoWordPopup;